import React from 'react';
import './Footer.scss';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__section">
          <h3 className="footer__title">Health Query</h3>
          <p className="footer__text">
            Get quick answers to your health-related questions. Always consult with a healthcare
            professional for medical advice.
          </p>
        </div>
        
        <div className="footer__section">
          <h4 className="footer__subtitle">Quick Links</h4>
          <ul className="footer__links">
            <li><a href="#about">About Us</a></li>
            <li><a href="#terms">Terms of Service</a></li>
            <li><a href="#privacy">Privacy Policy</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} Health Query. All rights reserved.
          </p>
          <p className="footer__disclaimer">
            This app is not a substitute for professional medical advice.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 